import React, {useMemo} from 'react'
import BreadcrumbItem from '../../../components/breadcrumb/breadcrumb-item'
import Breadcrumb from '../../../components/breadcrumb'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import {useIntl} from 'react-intl'
import {normalizeSfccLink} from '../../../utils/url'
import {HYBRID_CUSTOMER_SERVICE} from '../../../constants'

const CSBreadcrumbs = () => {
    const {locale} = useIntl()
    const pageConfig = useCustomerServicePageConfig()
    const {breadcrumbs} = pageConfig

    const normalizedBreadcrumbs = useMemo(
        () =>
            breadcrumbs?.map(({link, label}) => ({
                label,
                href: normalizeSfccLink(locale, link)
            })) ?? [],
        [breadcrumbs, locale]
    )

    return (
        <Breadcrumb>
            {normalizedBreadcrumbs.map(({label, href}, index) => (
                <BreadcrumbItem key={index} href={href} page={HYBRID_CUSTOMER_SERVICE}>
                    {label}
                </BreadcrumbItem>
            ))}
        </Breadcrumb>
    )
}

export default CSBreadcrumbs
